module.exports = __webpack_public_path__ + "static/assets/b271d058008e58e43bf0f04c4db6416c.png";